var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFastTrackInstruct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83203 0.333008C1.45131 0.333008 0.332031 1.45229 0.332031 2.83301C0.332031 4.21372 1.45131 5.33301 2.83203 5.33301H31.1654C32.546 5.33301 33.6654 4.21372 33.6654 2.83301C33.6654 1.45229 32.546 0.333008 31.1654 0.333008H2.83203ZM31.9987 7.83301H1.9987V23.6663C1.9987 25.5073 3.49108 26.9997 5.33203 26.9997H15.7487V33.6663C15.7487 34.3567 16.3084 34.9163 16.9987 34.9163C17.689 34.9163 18.2487 34.3567 18.2487 33.6663V26.9997H28.6654C30.5064 26.9997 31.9987 25.5073 31.9987 23.6663V7.83301ZM24.7372 14.3097C25.0924 13.7177 24.9004 12.9498 24.3085 12.5947C23.7165 12.2395 22.9487 12.4314 22.5935 13.0234L20.7897 16.0297C20.1737 17.0563 18.7227 17.154 17.9747 16.219C16.1385 13.9237 12.5763 14.1632 11.0639 16.6838L9.26015 19.69C8.90497 20.282 9.09692 21.0498 9.6889 21.405C10.2809 21.7602 11.0487 21.5683 11.4039 20.9763L13.2076 17.97C13.8237 16.9433 15.2747 16.8458 16.0225 17.7807C17.8589 20.0762 21.421 19.8365 22.9335 17.3158L24.7372 14.3097Z",
    fill: "#F8D210"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastTrackInstruct);
export default __webpack_public_path__ + "static/media/fastTrackInstruct.4d3ea49efa150deea686694b25b6293d.svg";
export { ForwardRef as ReactComponent };